import type { APIGatewayEvent } from 'aws-lambda';
import { InternalServerError } from 'http-errors';

export type AuthorizerContextKeys = 'tenant' | 'userId' | 'user' | 'givenName' | 'familyName' | 'dataplaneId' | 'possibleTenantIds';

export const getAuthorizerContextValue = (event: APIGatewayEvent, key: AuthorizerContextKeys): string | undefined => {
  return event.requestContext.authorizer?.[key];
};

export const assertAuthorizerContextValue = (event: APIGatewayEvent, key: AuthorizerContextKeys): string => {
  const value = getAuthorizerContextValue(event, key);
  if (!value) {
    throw new InternalServerError(`Could not find ${key} as part of the context`);
  }
  return value;
};

export const assertTenantIdAndGet = (event: APIGatewayEvent) => assertAuthorizerContextValue(event, 'tenant');

export const assertDataplaneIdAndGet = (event: APIGatewayEvent) => assertAuthorizerContextValue(event, 'dataplaneId');
